import { sleep, objToQs } from './util.js';

const BackendUrl = BACKEND_URL;

export default async function apiRequest(uri, opt = {}) {
  const { post } = opt;
  const startSleepTime = opt.startSleepTime || 3000;
  const maxRetry = opt.maxRetry || 4;
  const needsRetry = opt.needsRetry || (() => false);

  let retry = 0;
  let response;
  let sleepTime = startSleepTime;

  const url = `${BackendUrl}${uri}`;

  while (true) {
    if (post) {
      response = await fetch(uri, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: objToQs(post),
      });
    } else {
      response = await fetch(url);
    }

    const retriableResponse = response.status >= 500 || response.status === 429;
    const shouldRetry = (await needsRetry(response)) || retriableResponse;
    const belowMaxRetries = retry < maxRetry;

    if (belowMaxRetries && shouldRetry) {
      await sleep(sleepTime);
      retry++;
      sleepTime *= 2;
    } else {
      break;
    }
  }
  return response;
}
